<template>
  <div class="container-resizable">
    <div class="card-info-circle">
      <img class="image-circle" src="../../assets/layout/images/servicios_salas.jpg" alt="salas" />
      <div class="container-info">
        <div>
          <h2 class="title-info-circle">
            {{ $t("messages.operatingRooms") }}
          </h2>
          <p class="data-info-circle">
            {{ $t("messages.operatingRoomsDescription") }}            
          </p>
        </div>
        <div class="boton-info-circle" @click="$router.push({ name: 'services_main' })">
          <i class="mdi mdi-arrow-right"></i> {{$t("messages.go")}}
        </div>
      </div>
    </div>
    <div class="card-info-circle">
      <img class="image-circle" src="../../assets/layout/images/servicios2.png" alt="salas" />
      <div class="container-info">
        <div>
          <h2 class="title-info-circle">
            {{$t("messages.surgeonWellness")}}
          </h2>
          <p class="data-info-circle">
            {{$t("messages.surgeonWellnessDescription")}}            
          </p>
        </div>
        <div class="boton-info-circle" @click="$router.push({ name: 'bienestar_cirujanos' })">
          <i class="mdi mdi-arrow-right"></i> {{$t("messages.go")}}
        </div>
      </div>
    </div>
    <div class="card-info-circle">
      <img class="image-circle" src="../../assets/layout/images/servicios3.png" alt="salas" />
      <div class="container-info">
        <div>
        <h2 class="title-info-circle">
          {{$t("messages.patientWellness")}}
        </h2>
        <p class="data-info-circle">
          {{$t("messages.patientWellnessDescription")}}
        </p>
      </div>
        <div class="boton-info-circle" @click="$router.push({ name: 'bienestar_pacientes' })">
          <i class="mdi mdi-arrow-right"></i> {{$t("messages.go")}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalInfoCircles",
};
</script>

<style scoped>
.container-resizable {
  background-color: #7bb6df;
  justify-content: space-around;
  align-items: flex-start;
  padding: 50px 300px;
  display: flex;
  flex-wrap: wrap;
}

.card-info-circle {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid rgb(206, 206, 206);
  width: 610px;  
}

.image-circle {
  height: auto;
  border-radius: 50%;
  margin-bottom: 10px;
  width: 160px;
}

.container-info {
  height: 100%;
  width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px;
}

.title-info-circle {
  font-weight: 600;
  margin: 0px;
  color: #ffffff;
  margin-bottom: 5px;
  text-align: center;
  font-size: 1.4rem;
}

.data-info-circle {
  margin: 0px;
  color: #ffffff;
  font-size: 1.1rem;
  margin-bottom: 25px;
  text-align: center;
}

.boton-info-circle {
  width: 110px;
  background-color: #ffffff;
  color: #62b0de;
  padding: 5px;
  border-radius: 9999px;
  text-align: center;
  font-weight: bold;
  align-items: center;
  display: flex;
  justify-content: center;
  letter-spacing: 1.3px;
  cursor: pointer;
  transition: 0.5s all;
  border: 1px solid #ffffff;
  user-select: none;
  margin: 0px auto;
}

.boton-info-circle:hover {
  background-color: #349fdd;
  border: 1px solid #ffffff;
  color: #ffffff;
}


@media screen and (max-width: 1510px) {
  .container-resizable {
    padding: 50px 50px;
  }
}

@media screen and (max-width: 750px) {
  .card-info-circle {
    width: 100%;
    margin-bottom: 40px;
    flex-direction: column;
    align-items: center;
    height: fit-content;
  }

  .container-info {
    justify-content: flex-start;
    padding-left: 0px;
    width: 100%;
  }


  .image-circle {
    height: 112px;
    border-radius: 50%;
    margin-bottom: 10px;
    width: auto;
  }

}
</style>
